module.exports = __webpack_public_path__ + "img/splash-main6.7a8d2e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/splash-main6.png
// module id = 617
// module chunks = 5